import {MipLevelRegion, Regions} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-descriptor"
import {ImageOpContextHal} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-context-hal"
import {CreateDataArgs, ImageOpHal} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal"
import {RegionLockedHalImageRef} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/region-locked-hal-image-ref"
import {definition} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/output-node/definition"
import {HalImage} from "@cm/hal"
import {ImageOpHalParameters, UpdateImageOptions} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal-types"
import {AnyImageOpHalData, CtorArgs, ImageOpHalData} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal-data"
import {UPDATE_COMPLEXITY_VERY_LOW} from "@app/textures/texture-editor/operator-stack/image-op-system/helpers/update-complexity"

type Definition = typeof definition

export class ImageOpOutputHal extends ImageOpHal<Definition, ImageOpOutputHalData> {
    constructor(ctx: ImageOpContextHal, parameters: ImageOpHalParameters<Definition>) {
        super(ctx)
        this.setParameters(parameters)
    }

    protected override createData(args: CreateDataArgs<Definition, ImageOpOutputHalData>): ImageOpOutputHalData {
        return new ImageOpOutputHalData({
            ...args,
            descriptor: args.parameters.sourceImage.descriptor,
            outputImageReuse: "no-output-image",
            updateComplexity: UPDATE_COMPLEXITY_VERY_LOW,
            cachingStrategy: "always",
        })
    }
}

class ImageOpOutputHalData extends ImageOpHalData<Definition> {
    readonly isOutput = true // TODO remove this hack

    constructor(args: CtorArgs<Definition, ImageOpOutputHalData>) {
        super(args)
    }

    protected override async updateHalImage(mipLevelRegion: MipLevelRegion, options?: UpdateImageOptions): Promise<RegionLockedHalImageRef> {
        return this.parameters.sourceImage.getUpdatedHalImage(mipLevelRegion, options)
    }

    protected override onSourceRegionsInvalidated(_sourceImage: AnyImageOpHalData, sourceRegions: Regions) {
        this.invalidateRegions(sourceRegions)
    }

    protected override async writeRegion(_outputImage: HalImage, _mipLevelRegion: MipLevelRegion, _options?: UpdateImageOptions): Promise<void> {
        throw new Error("Unexpected call to writeRegion in ImageOpOutputHal")
    }
}
